import { useRef } from "react";

export default function useCountRenders(component) {
  const renders = useRef(0);
  console.log(`${component} renders: `, renders.current++);
}
